"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function InsertContractPaymnetSchedSvg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    const id1 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 30, height: 25, viewBox: "0 0 30 25" }, props),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("filter", { id: `insertcontractpaymnetsched-${id0}`, width: "140%", height: "150%", x: "-20%", y: "-25%", filterUnits: "objectBoundingBox" },
                react_1.default.createElement("feOffset", { in: "SourceAlpha", result: "shadowOffsetOuter1" }),
                react_1.default.createElement("feGaussianBlur", { in: "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: 2 }),
                react_1.default.createElement("feColorMatrix", { in: "shadowBlurOuter1", values: "0 0 0 0 0 0 0 0 0 0.0705882353 0 0 0 0 0.278431373 0 0 0 0.1 0" })),
            react_1.default.createElement("path", { id: `insertcontractpaymnetsched-${id1}`, d: "M0 2.005C0 .898.898 0 1.992 0h26.016C29.108 0 30 .897 30 2.005v19.99C30 23.102 29.102 24 28.008 24H1.992C.892 24 0 23.103 0 21.995V2.005z" })),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", null,
                react_1.default.createElement("g", null,
                    react_1.default.createElement("g", null,
                        react_1.default.createElement("g", null,
                            react_1.default.createElement("g", { transform: "translate(-1000 -216) translate(980 20.5) translate(0 187) translate(20 9)" },
                                react_1.default.createElement("use", { fill: "#000", filter: `url(#insertcontractpaymnetsched-${id0})`, xlinkHref: `#insertcontractpaymnetsched-${id1}` }),
                                react_1.default.createElement("use", { fill: "#FFF", xlinkHref: `#insertcontractpaymnetsched-${id1}` })),
                            react_1.default.createElement("g", { fill: "#DEE5FF", fillRule: "nonzero", transform: "translate(-1000 -216) translate(980 20.5) translate(0 187) translate(20 9) translate(3 4)" },
                                react_1.default.createElement("rect", { width: 24, height: 16, rx: 1 })),
                            react_1.default.createElement("g", { fill: "#8AA4FF", fillRule: "nonzero" },
                                react_1.default.createElement("path", { d: "M2 8v2H0V8h2zm4 0v2H4V8h2zm0-4v2H4V4h2zm4 0v2H8V4h2zM2 4v2H0V4h2zm4-4v2H4V0h2zM2 0v2H0V0h2zm8 0v2H8V0h2zM16 0c.414 0 .75.336.75.75v.706c.786.079 1.562.321 2.12.686l-.602 1.122c-.675-.383-1.522-.62-2.196-.62-.646 0-1.12.197-1.12.699 0 1.294 4.062.594 4.048 3.142 0 1.223-1.005 1.874-2.25 2.042v.723c0 .38-.282.693-.648.743L16 10c-.414 0-.75-.336-.75-.75v-.739c-.852-.124-1.674-.437-2.25-.917l.589-1.082c.66.541 1.722.871 2.555.871.703 0 1.248-.224 1.248-.752 0-1.44-4.019-.634-4.004-3.17 0-1.106.812-1.72 1.861-1.939L15.25.75c0-.38.282-.693.648-.743L16 0z", transform: "translate(-1000 -216) translate(980 20.5) translate(0 187) translate(20 9) translate(5 7)" }))))))));
}
function InsertContractPaymnetSched(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(InsertContractPaymnetSchedSvg, Object.assign({}, svgProps)));
}
exports.default = InsertContractPaymnetSched;
//# sourceMappingURL=InsertContractPaymnetSched.js.map